import { WidgetType } from '../WidgetType';
import {
    WidgetSharedState,
    initialWidgetSharedState,
} from './shared/WidgetsSharedState';
import { UnknownWidgetsState } from '../unknown/store/UnknownWidgetState';
import {
    FillsGraphWidgetsState,
    initialFillsGraphWidgetsState,
} from 'widgets/fillsGraph/store/FillsGraphWidgetState';
import {
    LiquiditySummaryWidgetsState,
    initialLiquiditySummaryWidgetsState,
} from 'widgets/liquiditySummary/store/LiquiditySummaryWidgetState';
import {
    BlotterWidgetsState,
    initialBlotterWidgetsState,
} from 'widgets/blotter/store/BlotterWidgetState';
import {
    PortfolioReturnsWidgetsState,
    initialPortfolioReturnsWidgetsState,
} from 'widgets/portfolioReturns/store/PortfolioReturnsWidgetState';
import {
    IntraDayProfileWidgetsState,
    initialIntraDayProfileWidgetsState,
} from 'widgets/intraDayProfile/store/IntraDayProfileWidgetState';
import {
    PortfolioSummaryWidgetsState,
    initialPortfolioSummaryWidgetsState,
} from 'widgets/portfolioSummary/store/instances/PortfolioSummaryWidgetsState';
import {
    StrategyParametersWidgetsState,
    initialStrategyParametersWidgetsState,
} from 'widgets/strategyParams/store/StrategyParametersWidgetState';
import {
    VenueAnalysisWidgetsState,
    initialVenueAnalysisWidgetsState,
} from 'widgets/venueAnalysis/store/VenueAnalysisWidgetState';
import { OpenSubmissionsWidgetsState } from 'widgets/openSubmissions/store/OpenSubmissionsWidgetState';
import { initialOpenSubmissionsWidgetsState } from '../openSubmissions/store/OpenSubmissionsWidgetState';
import { ExpertiseWidgetsState } from 'widgets/expertise/store/ExpertiseWidgetState';
import { initialExpertiseWidgetsState } from '../expertise/store/ExpertiseWidgetState';
import {
    initialPortfolioPlWidgetsState,
    PortfolioPlWidgetsState,
} from 'widgets/portfolioPl/store/PortfolioPlWidgetState';
import {
    initialTilesWidgetsState,
    CapsuleContainersWidgetsState,
} from 'widgets/tiles/store/CapsuleContainerWidgetState';
import { VolumeCapsuleWidgetsState } from 'widgets/liquiditySummary/volumeCapsule/state/VolumeCapsuleState';
import {
    initialPortfolioSummaryDataState,
    PortfolioSummaryDataState,
} from 'widgets/portfolioSummary/store/data/PortfolioSummaryDataState';
import {
    initialWidgetsSharedConfigState,
    WidgetsSharedConfigState,
} from 'widgets/store/sharedConfiguration/WidgetsSharedConfigState';
import { SymbolTileWidgetInstancesState } from 'widgets/symbolTile/store/instances/SymbolTileWidgetInstanceState';
import {
    initialOpenSubmissionsCapsuleWidgetsState,
    OpenSubmissionsCapsuleWidgetsState,
} from 'widgets/openSubmissions/capsule/store/OpenSubmissionsCapsuleWidgetState';
import { SignalTilesState } from 'widgets/signalTiles/signalTile/state/SignalTileState';
import { CandlestickTileWidgetsState } from 'widgets/candlestickTile/store/CandlestickTileState';
import { ObvTileWidgetsState } from 'widgets/obvTile/store/ObvTileState';
import {
    initialMyPortfolioCapsulesWidgetsState,
    MyPortfolioCapsulesWidgetsState,
} from 'widgets/myPortfolioCapsules/store/MyPortfolioCapsulesWidgetsState';
import {
    initialMyPortfolioCapsulesDataState,
    MyPortfolioCapsulesDataState,
} from 'widgets/myPortfolioCapsules/store/data/MyPortfolioCapsulesDataState';
import { VenueAnalysisCapsuleWidgetsState } from 'widgets/venueAnalysis/capsules/store/VenueAnalysisCapsuleState';
import { CorporateActionsWidgetsState } from 'widgets/corpActions/widget/store/CorporateActionsWidgetState';
import { CorporateActionsDataState } from 'widgets/corpActions/store/data/CorporateActionsDataState';
import { SymbolInfoCapsuleWidgetsState } from 'widgets/symbolInfo/capsule/store/SymbolInfoCapsuleState';
import { CorporateActionsCapsulesState } from 'widgets/corpActions/capsule/store/CorporateActionsCapsulesState';
import { OutliersWidgetsState } from 'widgets/outliers/store/OutliersWidgetState';
import { PerfVsIndexCapsuleWidgetsState } from 'widgets/perfVsIndexCapsule/store/PerfVsIndexCapsuleState';
import { PlCapsuleWidgetsState } from 'widgets/plCapsule/store/PlCapsuleState';
import { PredictedVolumeCapsuleWidgetsState } from 'widgets/liquiditySummary/predictedVolumeCapsule/state/PredictedVolumeCapsuleState';
import { WidgetWithTabTitleState } from 'widgets/tabTitle/WidgetConfigWithTabTitle';
import { EstimatedTradeCostWidgetsState } from 'widgets/estimatedTradeCost/widget/store/EstimatedTradeCostState';
import { EstimatedTradeCostDataState } from 'widgets/estimatedTradeCost/store/data/EstimateTradeCostDataState';
import { EstimatedTradeCostComparisonWidgetsState } from 'widgets/estimatedTradeCost/widget-comparison/store/EstimatedTradeCostComparisonState';
import { HistoricalPercentageChangeWidgetsState } from 'widgets/historicalPercentageChange/store/HistoricalPercentageChangeWidgetsState.ts';
import { DarkVenueHeatmapDataState } from 'widgets/darkVenueHeatmap/store/data/DarkVenueHeatmapDataState.ts';
import { DarkVenueHeatmapWidgetsState } from 'widgets/darkVenueHeatmap/store/DarkVenueHeatmapState';
import {
    initialVolumeCurveWidgetsState,
    VolumeCurveWidgetsState,
} from 'widgets/volumeCurve/store/VolumeCurveWidgetState.ts';
import {
    initialOrderVolumeProfileWidgetsState,
    OrderVolumeProfileWidgetsState,
} from '../orderVolumeProfile/store/OrderVolumeProfileWidgetState';
import {
    IndexEventsWidgetsState,
    initialIndexEventsWidgetsState,
} from 'widgets/indexEvents/store/IndexEventsWidgetState';
import { IndexEventsDataState } from 'widgets/indexEvents/store/data/IndexEventsDataState';

export interface WidgetState<T> {
    [widgetKey: string]: T;
}

export interface WidgetInstancesState {
    [WidgetType.BLOTTER]: BlotterWidgetsState;
    [WidgetType.CANDLESTICK_TILE]: CandlestickTileWidgetsState;
    [WidgetType.CORPORATE_ACTIONS]: CorporateActionsWidgetsState;
    [WidgetType.CORPORATE_ACTIONS_CAPSULE]: CorporateActionsCapsulesState;
    [WidgetType.DARK_VENUE_HEATMAP]: DarkVenueHeatmapWidgetsState;
    [WidgetType.EST_TRADE_COST_WIDGET]: EstimatedTradeCostWidgetsState;
    [WidgetType.EST_TRADE_COST_COMPARISON_WIDGET]: EstimatedTradeCostComparisonWidgetsState;
    [WidgetType.EXPERTISE_MAKE]: ExpertiseWidgetsState;
    [WidgetType.EXPERTISE_NIGHTHAWK]: ExpertiseWidgetsState;
    [WidgetType.EXPERTISE_DNA]: ExpertiseWidgetsState;
    [WidgetType.FILLS_GRAPH]: FillsGraphWidgetsState;
    [WidgetType.HistoricalPercentageChangeCapsule]: HistoricalPercentageChangeWidgetsState;
    [WidgetType.HistoricalPercentageChangeWidget]: HistoricalPercentageChangeWidgetsState;
    [WidgetType.INTRA_DAY_PROFILE]: IntraDayProfileWidgetsState;
    [WidgetType.INDEX_EVENTS]: IndexEventsWidgetsState;
    [WidgetType.LIQUIDITY_SUMMARY]: LiquiditySummaryWidgetsState;
    [WidgetType.MY_PORTFOLIO_CAPSULES]: MyPortfolioCapsulesWidgetsState;
    [WidgetType.ORDER_FILLS_BY_VENUE_CAPSULE]: VenueAnalysisCapsuleWidgetsState;
    [WidgetType.ORDER_FILLS_BY_VENUE_TYPE_CAPSULE]: VenueAnalysisCapsuleWidgetsState;
    [WidgetType.ORDER_LIQUIDITY_CAPSULE]: VenueAnalysisCapsuleWidgetsState;
    [WidgetType.OPEN_SUBMISSIONS]: OpenSubmissionsWidgetsState;
    [WidgetType.OPEN_SUBMISSIONS_CAPSULE]: OpenSubmissionsCapsuleWidgetsState;
    [WidgetType.ORDER_VOLUME_PROFILE]: OrderVolumeProfileWidgetsState;
    [WidgetType.OUTLIERS_WIDGET]: OutliersWidgetsState;
    [WidgetType.PERF_VS_INDEX_CAPSULE]: PerfVsIndexCapsuleWidgetsState;
    [WidgetType.PL_CAPSULE]: PlCapsuleWidgetsState;
    [WidgetType.PORTFOLIO_PL]: PortfolioPlWidgetsState;
    [WidgetType.PORTFOLIO_RETURNS]: PortfolioReturnsWidgetsState;
    [WidgetType.PORTFOLIO_SUMMARY]: PortfolioSummaryWidgetsState;
    [WidgetType.PREDICTED_CLOSE_VOLUME_CAPSULE]: PredictedVolumeCapsuleWidgetsState;
    [WidgetType.PREDICTED_VOLUME_CAPSULE]: PredictedVolumeCapsuleWidgetsState;
    [WidgetType.VOLUME_CAPSULE]: VolumeCapsuleWidgetsState;
    [WidgetType.OBV_TILE]: ObvTileWidgetsState;
    [WidgetType.PFE_TILE]: SignalTilesState;
    [WidgetType.RSI_TILE]: SignalTilesState;
    [WidgetType.SUPPORT_VISUALISATION]: WidgetState<WidgetWithTabTitleState>;
    [WidgetType.TRADE_OPTIMIZER]: WidgetState<WidgetWithTabTitleState>;
    [WidgetType.STRATEGY_PARAMETERS]: StrategyParametersWidgetsState;
    [WidgetType.SYMBOL_INFO]: WidgetState<WidgetWithTabTitleState>;
    [WidgetType.SYMBOL_INFO_CAPSULE]: SymbolInfoCapsuleWidgetsState;
    [WidgetType.SYMBOL_TILE]: SymbolTileWidgetInstancesState;
    [WidgetType.TILES]: CapsuleContainersWidgetsState;
    [WidgetType.VENUE_ANALYSIS]: VenueAnalysisWidgetsState;
    [WidgetType.VENUE_TYPE_CAPSULE]: VenueAnalysisCapsuleWidgetsState;
    [WidgetType.VENUE_EXEC_CAPSULE]: VenueAnalysisCapsuleWidgetsState;
    [WidgetType.VOLUME_CURVE]: VolumeCurveWidgetsState;
    [WidgetType.UNKNOWN]: UnknownWidgetsState;
}

export interface WidgetsDataState {
    corporateActions: CorporateActionsDataState;
    estimatedTradeCost: EstimatedTradeCostDataState;
    darkVenueHeatmap: DarkVenueHeatmapDataState;
    indexEvents: IndexEventsDataState;
    myPortfolioCapsulesData: MyPortfolioCapsulesDataState;
    portfolio: PortfolioSummaryDataState;
}

export default interface WidgetsState {
    data: WidgetsDataState;
    instances: WidgetInstancesState;
    shared: WidgetSharedState;
    sharedConfig: WidgetsSharedConfigState;
}

export const initialWidgetsDataState: WidgetsDataState = {
    corporateActions: {},
    estimatedTradeCost: {},
    darkVenueHeatmap: {},
    indexEvents: {},
    myPortfolioCapsulesData: initialMyPortfolioCapsulesDataState(),
    portfolio: initialPortfolioSummaryDataState,
};

export const initialWidgetInstancesState: WidgetInstancesState = {
    blotter: initialBlotterWidgetsState,
    candlestickTile: {},
    corporateActions: {},
    corporateActionsCapsule: {},
    [WidgetType.EST_TRADE_COST_WIDGET]: {},
    [WidgetType.EST_TRADE_COST_COMPARISON_WIDGET]: {},
    [WidgetType.DARK_VENUE_HEATMAP]: {},
    expertiseMake: initialExpertiseWidgetsState,
    expertiseNighthawk: initialExpertiseWidgetsState,
    expertiseDna: initialExpertiseWidgetsState,
    fillsGraph: initialFillsGraphWidgetsState,
    [WidgetType.HistoricalPercentageChangeCapsule]: {},
    [WidgetType.HistoricalPercentageChangeWidget]: {},
    [WidgetType.INDEX_EVENTS]: initialIndexEventsWidgetsState,
    intradayProfiles: initialIntraDayProfileWidgetsState,
    liquiditySummary: initialLiquiditySummaryWidgetsState,
    myPortfolioCapsules: initialMyPortfolioCapsulesWidgetsState,
    orderFillsByVenueCapsule: {},
    orderFillsByVenueTypeCapsule: {},
    orderLiquidityCapsule: {},
    outliersWidget: {},
    openSubmissions: initialOpenSubmissionsWidgetsState,
    [WidgetType.ORDER_VOLUME_PROFILE]: initialOrderVolumeProfileWidgetsState,
    [WidgetType.OPEN_SUBMISSIONS_CAPSULE]:
        initialOpenSubmissionsCapsuleWidgetsState,
    perfVsIndexCapsule: {},
    plCapsule: {},
    portfolioPl: initialPortfolioPlWidgetsState,
    portfolioReturns: initialPortfolioReturnsWidgetsState,
    portfolioSummary: initialPortfolioSummaryWidgetsState,
    predictedCloseVolumeCapsule: {},
    predictedVolumeCapsule: {},
    predictedVsActualTile: {},
    obvTile: {},
    pfeTile: {},
    rsiTile: {},
    supportVisualisation: {},
    strategyParameters: initialStrategyParametersWidgetsState,
    symbolInfo: {},
    symbolInfoCapsule: {},
    symbolTile: {},
    tiles: initialTilesWidgetsState,
    [WidgetType.TRADE_OPTIMIZER]: {},
    venueAnalysis: initialVenueAnalysisWidgetsState,
    venueExecCapsule: {},
    venueTypeCapsule: {},
    volumeCurve: initialVolumeCurveWidgetsState,
    unknown: {},
};

export const initialWidgetsState: WidgetsState = {
    data: initialWidgetsDataState,
    instances: initialWidgetInstancesState,
    shared: initialWidgetSharedState,
    sharedConfig: initialWidgetsSharedConfigState,
};
